/**
 * ExamController.java 对应的 model
 */

import Model from './model'
const model = new Model()

class Exam {

    /**
     * 获取待作答试卷个数
     * @returns {*}
     */
    static getUndoCount(params) {
        return model.post('exam/getPrepareExamsCount')
    }

    /**
     * 获取待作答
     * @params
     * @returns {*}
     */
    static getUndoList(params) {
        return model.post('exam/getPrepareExams', params)
    }

}
export default Exam


// WEBPACK FOOTER //
// ./bootsets/models/exam.js